import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { tok } from '../theme/businessTheme';

interface Props {
  businessName: string;
  onContinue: () => void;
  onDismiss: () => void;
}

/** Small card shown once at the end of the thread after a submission. */
const AppHandoffCard: React.FC<Props> = ({ businessName, onContinue, onDismiss }) => (
  <Box
    sx={{
      position: 'relative',
      my: 1.5,
      p: 2,
      pr: 5,
      borderRadius: '16px',
      background: tok('card'),
      border: `1px solid ${tok('cardBorder')}`,
      color: tok('onSurface'),
    }}
  >
    <IconButton
      size="small"
      aria-label="Dismiss"
      onClick={onDismiss}
      sx={{ position: 'absolute', top: 6, right: 6, color: tok('onSurfaceMuted') }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
    <Typography sx={{ fontWeight: 700, fontSize: 15 }}>📱 Keep this in the Paiper app</Typography>
    <Typography sx={{ fontSize: 14, color: tok('onSurfaceMuted'), mt: 0.5, mb: 1.25 }}>
      See your appointment, change it, or message {businessName} anytime.
    </Typography>
    <Button
      variant="contained"
      size="small"
      onClick={onContinue}
      sx={{
        textTransform: 'none',
        fontWeight: 700,
        borderRadius: 999,
        boxShadow: 'none',
        background: tok('action'),
        color: tok('onAction'),
        '&:hover': { background: tok('action'), boxShadow: 'none' },
      }}
    >
      Continue in the app
    </Button>
  </Box>
);

export default AppHandoffCard;
